import * as React from 'react'
import { MEMBERSHIPSUCCES_UPDATE_STATUS, MEMBERSHIPSUCCES_UPDATING_STATUS } from '../../state/constants'
import Loading from '../icons/membership/Loading'
import Success from '../icons/membership/Success'

export interface IMembershipStatus {
  status: string
  toggleModal: () => void
  apply: () => void
}

const MembershipStatus = (props: IMembershipStatus) => (
  <React.Fragment>
    {props.status === '' && (
      <div className='flex mt-auto col-12 mt-auto'>
        <div className='ml-auto col-4 py1 center cursor--pointer font-light-grey4 bold' onClick={props.toggleModal}>
          Cancel
        </div>
        <div className='col-4 py1 center cursor--pointer bg-green ml1 rounded font-white bold' onClick={props.apply}>
          Apply
        </div>
      </div>
    )}
    {props.status === MEMBERSHIPSUCCES_UPDATE_STATUS && (
      <div className='absolute flex top-0 left-0 right-0 bottom-0 bg-light-grey5 items-center justify-center'>
        <div className='col-12 justify-center flex flex-wrap items-center'>
          <Success className='col-3' />
          <div className='col-10 h5 font-dark-grey center mt2'>Membership Processed</div>
          <div className='col-10 h6 font-grey center'>Ingrid India was successfully added to service PSTA DART</div>
        </div>
      </div>
    )}

    {props.status === MEMBERSHIPSUCCES_UPDATING_STATUS && (
      <div className='flex items-center mt-auto'>
        <span className='ml-auto bold font-dark-grey h5'>Applying</span>
        <Loading className='col-1 ml1 animation-updating' />
      </div>
    )}
  </React.Fragment>
)

export default MembershipStatus



// WEBPACK FOOTER //
// ./src/components/membership-request/MembershipStatus.tsx